// extracted by mini-css-extract-plugin
module.exports = {"payInMoreTaglineHeading":"style_payInMoreTaglineHeading__nwA_x"};